import { render, staticRenderFns } from "./withdrawcharges.vue?vue&type=template&id=dfff3694"
import script from "./withdrawcharges.vue?vue&type=script&lang=js"
export * from "./withdrawcharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports